import moment from 'moment';
import { numberUnmask, removeSpace } from 'utils/masks';

export default {
  'debitCard.accountHolderName': [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (!formData.isDebitCardExisting || formData.isEditingDebitCard) {
        if (!input || (input && input.trim().length === 0)) {
          return 'The input field is required';
        }
      }
      return true;
    },
  }],
  'debitCard.cardNumber': [
    {
      rule: 'required',
      isValid: (input, err, opt, formData) => {
        if (!formData.isDebitCardExisting || formData.isEditingDebitCard) {
          if (!input) {
            return 'The input field is required';
          }

          if (numberUnmask(input).length < 16) {
            return 'Card number is not valid';
          }

          if (
            !numberUnmask(input).startsWith('4')
            && !numberUnmask(input).startsWith('5')
            && !numberUnmask(input).startsWith('6')
          ) {
            return 'Currently we accept only Discover, Visa or Mastercard';
          }
        }
        return true;
      },
    },
  ],
  'debitCard.expirationDate': [
    {
      rule: 'required',
      isValid: (input, err, opt, formData) => {
        if (!formData.isDebitCardExisting || formData.isEditingDebitCard) {
          if (!input) {
            return 'The input field is required';
          }

          if (numberUnmask(input).length < 4 || !moment(input, 'MM/YY').isValid()) {
            return 'Expiration Date is not valid';
          }

          const dateSplit = input.split('/');
          const normalizedDate = `${dateSplit[0]}/20${dateSplit[1]}`;

          return moment(normalizedDate, 'MM/YYYY').endOf('month').isSameOrBefore(moment().startOf('month')) ? 'Expiration Date is not valid' : true;
        }
      },
    },
  ],
  isSelfSubmitted: [
    {
      rule: 'required',
      isValid: (input) => {
        if (!input) {
          return 'The input field is required';
        }
        return true;
      },
    },
  ],
  'autoBankAccount.bankName': [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (formData.isSelfSubmitted === 2) {
        if (!formData.isBankAccountExisting || formData.isEditingBankInfo) {
          if (!input) {
            return 'The input field is required';
          }
        }
      }
      return true;
    },
  }],
  'autoBankAccount.accountHolderName': [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (formData.isSelfSubmitted === 2) {
        if (!formData.isBankAccountExisting || formData.isEditingBankInfo) {
          if (!input || removeSpace(input).length === 0) {
            return 'The input field is required';
          }
          if (input.length > 40) {
            return 'The input field is too long';
          }
          if (input.trim().split(' ').length < 2) {
            return 'Please enter your full name';
          }
          if (!/^[a-zA-Z\s-']+$/.test(input)) {
            return 'Please enter a valid name, with only letters, - and \'.';
          }
          return true;
        }
      }
      return true;
    },
  }],
  'autoBankAccount.routingNumber': [
    {
      rule: 'required',
      isValid: (input, err, opt, formData) => {
        if (formData.isSelfSubmitted === 2) {
          if (!formData.isBankAccountExisting || formData.isEditingBankInfo) {
            if (!input) {
              return 'The input field is required';
            }

            if (numberUnmask(input).length < 9) {
              return 'Routing Number is not valid';
            }
          }
        }
        return true;
      },
    },
  ],
  'autoBankAccount.accountNumber': [
    {
      rule: 'required',
      isValid: (input, err, opt, formData) => {
        if (formData.isSelfSubmitted === 2) {
          if (!formData.isBankAccountExisting || formData.isEditingBankInfo) {
            if (!input) {
              return 'The input field is required';
            }
          }
        }
        return true;
      },
    },
  ],
  'autoBankAccount.accountType': [{
    rule: 'required',
    isValid: (input, err, opt, formData) => {
      if (formData.isSelfSubmitted === 2) {
        if (!formData.isBankAccountExisting || formData.isEditingBankInfo) {
          if (!input) {
            return 'The input field is required';
          }
        }
      }
      return true;
    },
  }],
  firstPaymentDate: [{
    rule: 'required',
    isValid: (input) => {
      if (!input) {
        return 'The input field is required';
      }

      if (numberUnmask(input).length < 8) {
        return 'Date of Birth is not valid';
      }

      if (!moment(input, 'MM/DD/YYYY').isValid()) {
        return 'First Payment Date is not valid';
      }

      const lowBound = moment().add(37, 'd');
      const upBound = moment().add(47, 'd');
      const inputDate = moment(input, 'MM-DD-YYYY');

      if (moment(inputDate).isBefore(lowBound, 'day') || moment(inputDate).isAfter(upBound, 'day')) {
        return `First Payment Date must be between ${lowBound.format('MM/DD/YYYY')} and ${upBound.format('MM/DD/YYYY')}.`;
      }
      return true;
    },
  }],
};
